import styled from 'styled-components';

const StyledTextCatName = styled.span`
  color: #555;
  font-weight: bold;
`;

export default StyledTextCatName;
